import * as React from "react";
import styles from "./../styles/components/backgroundImage.module.scss";
import PropTypes from "prop-types";
import Loading from "./LoadingOverlay";
const BACKGROUND = '/images/background2.jpg'
const BACKGROUND_LOGIN = '/images/background.jpg'
const BACKGROUND_HOME = '/images/background-home.jpg';

const BackgroundImage = props => {
  let image = BACKGROUND_LOGIN;
  if (props.home) 
    image = BACKGROUND_HOME;
  else if (props.signup)
    image = BACKGROUND;

  return (
    <Loading active={props.active} className={styles.main__form}>
      <main
        style={{ backgroundImage: `url(${image})` }}
        className={`${
          props.form
            ? [styles.main__background, styles.main__form].join(" ")
            : styles.main__background
        }`}
      >
        {props.children}
      </main>
    </Loading>
  );
};

BackgroundImage.propTypes = {
  background: PropTypes.string
};
export default BackgroundImage;
